














































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import RujukanHivInputModal from "@/components/modal/RujukanHivInputModal.vue";
import RujukanHivKonfirmasiModal from "@/components/modal/RujukanHivKonfirmasiModal.vue";
import { storeRujukanHiv } from "@/store/modules/RujukanHivStore";
import RujukanHivSvc from "@/services/RujukanHivService";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { getHumanDateTime } from "@/utility/DateUtils";
import { RujukanHivInterface, StatusRujukanHiv } from "@/types/rujukan_hiv";

@Component({
  components: {
    CardModalTtd,
    RujukanHivInputModal,
    RujukanHivKonfirmasiModal,
  },
  inject: {
    isReadOnly: { default: () => () => false },
  },
})
export default class CardRujukanHiv extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  modalInput = false;
  modalKonfirmasi = false;
  modalTtd = false;
  editData: RujukanHivInterface | null = null;
  konfirmasiItem: RujukanHivInterface | null = null;
  signItem: RujukanHivInterface | null = null;
  deleting = false;

  mounted() {
    this.reload();
  }

  reload() {
    storeRujukanHiv.getByRegister(this.register);
  }

  formatDate(date: string | null) {
    return date ? getHumanDateTime(date) : "-";
  }

  get items(): RujukanHivInterface[] {
    return storeRujukanHiv.items;
  }

  get loading() {
    return storeRujukanHiv.loading;
  }

  get stateuser() {
    return userModule.user;
  }

  get canMake() {
    if (this.readOnly) return false;
    return ["dokter", "perawat", "bidan"].includes(
      (this.stateuser.profesi || "").toLowerCase()
    );
  }

  resolveInstansiPenerima(item: RujukanHivInterface) {
    return (item.faskes_penerima && item.faskes_penerima.name) || item.instansi_penerima;
  }

  canSignItem(item: RujukanHivInterface) {
    if (this.readOnly) return false;
    return (
      !item.signed &&
      item.dokter_pengirim &&
      this.stateuser.id == item.dokter_pengirim.id
    );
  }

  canFillKonfirmasi(item: RujukanHivInterface) {
    return item.signed && item.konfirmasi_status === "belum" && this.canMake;
  }

  statusColor(status: StatusRujukanHiv) {
    const map: Record<StatusRujukanHiv, string> = {
      draft: "grey",
      terkirim: "blue",
      diterima: "green",
      ditolak: "red",
      ltfu: "orange darken-2",
    };
    return map[status] || "grey";
  }

  statusLabel(status: StatusRujukanHiv) {
    const map: Record<StatusRujukanHiv, string> = {
      draft: "Draft",
      terkirim: "Terkirim",
      diterima: "Diterima",
      ditolak: "Ditolak",
      ltfu: "LTFU (>30 hari)",
    };
    return map[status] || status;
  }

  openInput(item: RujukanHivInterface | null) {
    this.editData = item;
    this.modalInput = true;
  }

  openKonfirmasi(item: RujukanHivInterface) {
    this.konfirmasiItem = item;
    this.modalKonfirmasi = true;
  }

  openSign(item: RujukanHivInterface) {
    this.signItem = item;
    this.modalTtd = true;
  }

  async passTtd(password: string) {
    if (!this.signItem) return;

    const resp = await RujukanHivSvc.sign(this.signItem.id, { password });

    if (resp.data.status == "1") {
      this.modalTtd = false;
      appModule.NoticeDelay("Berhasil Tanda Tangan Rujukan HIV");
      appModule.addMsgTtd("");
      this.reload();
    } else {
      appModule.addMsgTtd(resp.data.message);
      this.modalTtd = true;
    }
  }

  onSaved() {
    this.reload();
  }

  print(item: RujukanHivInterface) {
    RujukanHivSvc.printPdf(item.id);
  }

  async remove(item: RujukanHivInterface) {
    if (!confirm("Anda yakin akan menghapus Rujukan HIV ini?")) return;
    if (this.deleting) return;

    this.deleting = true;
    try {
      const resp = await RujukanHivSvc.destroy(item.id);
      if (resp.data.status == "1") {
        appModule.NoticeDelay(resp.data.message);
        this.reload();
      }
    } finally {
      this.deleting = false;
    }
  }
}
